var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-filter-container"},[_c('el-radio-group',{model:{value:(_vm.isCategory),callback:function ($$v) {_vm.isCategory=$$v},expression:"isCategory"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("分类分组")]),_c('el-radio',{style:({ marginTop: '10px' }),attrs:{"label":false}},[_vm._v("一般分组")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }